/**
 * API Test Utility
 * 
 * This file provides functions to test the connectivity to the backend API
 * and diagnose common issues with API calls.
 */

const BASE_URL = 'http://127.0.0.1:8000/api';

async function testEndpoint(url, method = 'GET', body = null) {
    try {
        const options = {
            method,
            headers: {
                'Content-Type': 'application/json',
            },
        };

        if (body) {
            options.body = JSON.stringify(body);
        }

        const response = await fetch(url, options);
        const status = response.status;
        const data = await response.json().catch(() => null);

        console.log(`Testing ${method} ${url}`);
        console.log(`Status: ${status}`);
        console.log('Response:', data);
        console.log('-------------------');

        return { status, data };
    } catch (error) {
        console.error(`Error testing ${url}:`, error);
        return { status: 'Error', error: error.message };
    }
}

async function runTests() {
    console.log('Starting API endpoint tests...\n');

    // Test Student Registration
    await testEndpoint(`${BASE_URL}/register-student/`, 'POST', {
        email: 'test.student@example.com',
        password: 'TestPass123!',
        first_name: 'Test',
        last_name: 'Student'
    });

    // Test Trainer Registration
    await testEndpoint(`${BASE_URL}/register-trainer/`, 'POST', {
        email: 'test.trainer@example.com',
        password: 'TestPass123!',
        first_name: 'Test',
        last_name: 'Trainer',
        specialization: 'Web Development',
        experience: '5 years'
    });

    // Test Counselor Registration
    await testEndpoint(`${BASE_URL}/register-counselor/`, 'POST', {
        email: 'test.counselor@example.com',
        password: 'TestPass123!',
        first_name: 'Test',
        last_name: 'Counselor',
        specialization: 'Career Guidance',
        experience: '3 years'
    });

    // Test Login
    await testEndpoint(`${BASE_URL}/login/`, 'POST', {
        email: 'test.student@example.com',
        password: 'TestPass123!',
        userType: 'student'
    });

    // Test OTP Verification
    await testEndpoint(`${BASE_URL}/verify-otp/`, 'POST', {
        email: 'test.student@example.com',
        otp: '123456'
    });

    // Test Forgot Password
    await testEndpoint(`${BASE_URL}/forgot-password/`, 'POST', {
        email: 'test.student@example.com'
    });

    // Test Reset Password
    await testEndpoint(`${BASE_URL}/reset-password/`, 'POST', {
        email: 'test.student@example.com',
        otp: '123456',
        new_password: 'NewTestPass123!'
    });

    // Test Change Password (requires authentication)
    await testEndpoint(`${BASE_URL}/change-password/`, 'POST', {
        old_password: 'TestPass123!',
        new_password: 'NewTestPass123!'
    });

    console.log('\nAPI endpoint tests completed.');
}

// Run the tests
runTests();

// Make the utility available in the global window object for console testing
if (typeof window !== 'undefined') {
  window.apiTest = {
    testConnectivity: async () => {
      try {
        console.log('Testing API connectivity to backend...');
        const response = await fetch('https://lcb-backend-server.onrender.com/api/', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json'
          }
        });
        
        let data;
        try {
          data = await response.json();
        } catch (e) {
          const text = await response.text();
          console.log('Response text:', text);
          data = { text };
        }
        
        console.log('Direct API connectivity test result:', {
          status: response.status,
          ok: response.ok,
          data
        });
        
        return {
          status: response.status,
          ok: response.ok,
          data
        };
      } catch (error) {
        console.error('API connectivity test failed:', error);
        return {
          error: error.message
        };
      }
    },
    
    // Test a specific API endpoint directly (bypassing proxy)
    testEndpoint: async (endpoint, payload) => {
      try {
        const url = `https://lcb-backend-server.onrender.com/api/${endpoint}/`;
        console.log(`Testing direct API call to ${url}`, payload);
        
        const response = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Origin': window.location.origin
          },
          body: JSON.stringify(payload)
        });
        
        let data;
        try {
          data = await response.json();
        } catch (e) {
          const text = await response.text();
          console.log('Response not JSON:', text);
          data = { text };
        }
        
        console.log(`Endpoint ${url} direct response:`, {
          status: response.status,
          ok: response.ok,
          data
        });
        
        return {
          status: response.status,
          ok: response.ok,
          data
        };
      } catch (error) {
        console.error(`Direct endpoint test failed:`, error);
        return {
          error: error.message
        };
      }
    }
  };
} 